import { Dispatch, createContext } from "react";

export type TransactionState = {
  transaction: any;
  transactions: any[];
  isCompleted: boolean;
  error: any;
  loading: boolean;
};
export interface IContext {
  transaction: TransactionState;
  getTransactions?: any;
  createTransaction?: any;
  updateTransaction?: any;
  verifyBank?: any;
  getBanks?: any;
   
  transactionDispatch: Dispatch<any>;
}

export const initialTransactionState = {};

const TransactionContext = createContext(initialTransactionState as IContext);

export default TransactionContext;
